import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { formatWebinarDate } from "../../../helpers/formatWebinarDate";

export default function PastWebinars({ pastWebinars }) {
  // Helper function to check if a URL is a YouTube link
  const isYouTubeLink = (url) => {
    if (!url) return false;
    return url.includes("youtube.com") || url.includes("youtu.be");
  };
  return (
    <Box>
      <Typography variant="h4">Past Webinars</Typography>

      <Box sx={{ mt: 3 }}>
        <Grid container spacing={3}>
          {pastWebinars && pastWebinars.length >= 1 ? (
            <>
              {pastWebinars.map((item, index) => (
                <Grid item md={6} key={index}>
                  <Card sx={{ width: "100%" }}>
                    <Box
                      sx={{
                        height: "50px",
                        backgroundColor: "#023f53",
                        color: "white",
                        pl: 3,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CalendarMonthIcon />
                      <Typography sx={{ ml: 1 }}>
                        {formatWebinarDate(item.fields.webinarDate)}
                      </Typography>
                    </Box>
                    <CardContent>
                      {item.fields.webinarRecordingLink ? (
                        <>
                          {isYouTubeLink(item.fields.webinarRecordingLink) ? (
                            <iframe
                              width="515"
                              height="300"
                              src={`${item.fields.webinarRecordingLink}`}
                              style={{
                                border: "none",
                                borderRadius: "15px",
                                maxWidth: "100%",
                              }}
                              allowFullScreen
                              title="Embedded youtube"
                            />
                          ) : (
                            <Box
                              sx={{
                                position: "relative",
                                width: "515px",
                                height: "300px",
                                maxWidth: "100%",
                                borderRadius: "15px",
                                overflow: "hidden",
                                cursor: "pointer",
                                "&:hover .play-overlay": {
                                  opacity: 1,
                                },
                                "&:hover img": {
                                  transform: "scale(1.05)",
                                },
                              }}
                              onClick={() =>
                                window.open(
                                  item.fields.webinarRecordingLink,
                                  "_blank"
                                )
                              }
                            >
                              {item.fields.webinarImg ? (
                                <>
                                  <img
                                    src={item.fields.webinarImg.fields.file.url}
                                    alt={
                                      item.fields.webinarImg.fields.title ||
                                      "Webinar thumbnail"
                                    }
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      transition: "transform 0.3s ease",
                                    }}
                                  />
                                  <Box
                                    className="play-overlay"
                                    sx={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      backgroundColor: "rgba(0, 0, 0, 0.4)",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      opacity: 0,
                                      transition: "opacity 0.3s ease",
                                    }}
                                  >
                                    <IconButton
                                      sx={{
                                        backgroundColor: "white",
                                        color: "#023f53",
                                        width: 60,
                                        height: 60,
                                        "&:hover": {
                                          backgroundColor: "#f5f5f5",
                                        },
                                      }}
                                    >
                                      <PlayArrowIcon sx={{ fontSize: 40 }} />
                                    </IconButton>
                                  </Box>
                                </>
                              ) : (
                                <Box
                                  sx={{
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: "#023f53",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{ color: "white" }}
                                  >
                                    Click to Watch Webinar
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          )}
                        </>
                      ) : (
                        <>
                          <Box
                            sx={{
                              width: "515px",
                              height: "300px",
                              maxWidth: "100%",
                              borderRadius: "15px",
                              backgroundColor: "#023f53",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography variant="h4" sx={{ color: "white" }}>
                              Recording video will be available soon
                            </Typography>
                          </Box>
                        </>
                      )}

                      <Typography variant="h6" sx={{ fontWeight: 600, mt: 2 }}>
                        {item.fields.webinarTitle || ""}
                      </Typography>

                      <Typography>
                        {documentToReactComponents(item.fields.webinarExcerpt)}
                      </Typography>

                      {item.fields.webinarSlidedeckLink ? (
                        <>
                          <Button
                            variant="outlined"
                            onClick={() =>
                              window.open(
                                item.fields.webinarSlidedeckLink,
                                "_blank"
                              )
                            }
                          >
                            Download Webinar Slidedeck
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </>
          ) : (
            <>
              <Grid item md={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                      No past webinars found
                    </Typography>
                    <Typography>
                      It seems there are currently no past webinars found.
                      Please check back later for updates.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Box>
  );
}
